import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from 'src/constants';
import { useValuationSettings } from 'src/hooks/useValuationSettings';
import ApiService from 'src/modules/api-service';
import { SourceType } from 'src/modules/generated/api';

export const useRecommendations = () => {
  const { valuationCountry } = useValuationSettings();

  return useQuery(
    [QueryKeys.recommendations, valuationCountry],
    () =>
      ApiService.recommendation
        .recommendationControllerRecommendations(valuationCountry || undefined)
        .then((res) => res.data),
    {
      onError: (error) => console.error('[useRecommendations] failed to load recommendations', error),
    },
  );
};

export const useCarRecommendation = (source: SourceType | undefined, offerId: string | undefined) =>
  useQuery(
    [QueryKeys.carRecommendation, source, offerId],
    () => ApiService.recommendation.recommendationControllerRecommendedOffer(source!, offerId!).then((res) => res.data),
    {
      enabled: !!source && !!offerId,
      onError: (error) =>
        console.error('[useCarRecommendation] failed to load car recommendation', { source, offerId, error }),
    },
  );
